var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller("SitemapController", ["$scope", "sitemapService",
    function ($scope, sitemapService) {
        $scope.getSiteMapContent = function () {
            sitemapService.getSiteMapContent().then(function (response) {
                if (response && response.data && response.data.length > 0) {
                    $scope.sitemap_leftnode = response.data[0]['leftrow'];
                    $scope.sitemap_rightnode = response.data[1]['rightrow'];
                }
            });
        }
        $scope.getSiteMapContent();
    }
])
